<template>
  <div>
    <a-layout class="course-prepare-layout">
      <a-layout>
        <a-layout-sider
          width="300"
          style="background: #fff"
          v-model="collapsed"
          :trigger="null"
          collapsible
        >
          <h2 class="schedule-title">{{ courseInfo.courseName }}课表</h2>
          <a-menu
            mode="inline"
            :defaultSelectedKeys="['1']"
            :style="{
              height: 'calc(100vh - 124px)',
              borderRight: 0,
              overflowY: 'auto',
              overflowX: 'hidden',
            }"
            :inline-collapsed="collapsed"
            @openChange="onOpenChange"
          >
            <a-menu-item key="1" @click="getCourse">课程介绍</a-menu-item>
            <a-menu-item
              v-for="unit in courseUnits"
              :key="unit.id"
              @click="selectUnit(unit)"
            >
              <a-icon
                type="check"
                v-if="courseInfo.openMethod === 1 && unit.isUnitOpen === 1"
              />
              {{ unit.unitName }}
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout style="padding: 0 24px 24px">
          <a-layout-content
            :style="{
              background: '#fff',
              padding: '24px',
              margin: 0,
              height: 'calc(100vh - 120px)',
              overflow: 'auto',
            }"
          >
            <a-row>
              <a-col :span="4">
                <a-breadcrumb style="margin: 16px 0">
                  <a-breadcrumb-item
                    ><router-link to="/teacher/course"
                      >授课中心</router-link
                    ></a-breadcrumb-item
                  >
                  <a-breadcrumb-item>{{
                    departId ? "上课" : "备课"
                  }}</a-breadcrumb-item>
                </a-breadcrumb>
              </a-col>
              <a-col :span="10">
                <h2 class="lesson-title">
                  {{ selectedUnit.unitName || "课程介绍" }}
                </h2>
              </a-col>
              <a-col :span="10" v-show="showUnitInfo">
                <a
                  class="lesson-download"
                  v-if="courseInfo.courseNotes_url"
                  :href="courseInfo.courseNotes_url"
                  target="_blank"
                  ><a-icon type="download" />课程讲义下载</a
                >
                <span class="btn-wrap" v-if="departId && courseInfo.openMethod === 1">
                  <a-button
                    class="btn"
                    v-if="selectedUnit.isUnitOpen==1"
                    @click="setUnitOpen(0)"
                    >取消上课</a-button
                  >
                  <a-button
                    class="btn"
                    v-else
                    @click="setUnitOpen(1)"
                    >开始上课</a-button
                  >
                  <span v-if="getCoursewareByType(5) || getCoursewareByType(3)">
                    <a-button
                      v-if="!selectedUnit.isWorkOpen &&!selectedUnit.isWorkCaseOpen"
                      @click="showMakeWork = true"
                    >
                      布置作业
                    </a-button>
                    <a-button
                      v-if="(selectedUnit.isWorkOpen) ||selectedUnit.isWorkCaseOpen"
                      @click="showMakeWork = true"
                    >
                      取消作业
                    </a-button>
                  </span>
                </span>
              </a-col>
            </a-row>
            <a-spin :spinning="spinning">
              <div class="course-info" v-if="showCourseInfo">
                <a-row>
                  <a-col :span="4" style="text-align: right"
                    ><h3 class="course-meta-title">课程名称：</h3></a-col
                  >
                  <a-col :span="20" class="course-meta-value">{{
                    courseInfo.courseName
                  }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="4" style="text-align: right"
                    ><h2 class="course-meta-title">课程难度：</h2></a-col
                  >
                  <a-col :span="20" class="course-meta-value">{{
                    courseInfo.courseLevel_dictText
                  }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="4" style="text-align: right"
                    ><h2 class="course-meta-title">课程简介：</h2></a-col
                  >
                  <a-col :span="20" class="course-meta-value">{{
                    courseInfo.courseDesc
                  }}</a-col>
                </a-row>
                <a-row>
                  <a-col :span="4" style="text-align: right"
                    ><h2 class="course-meta-title">教学大纲：</h2></a-col
                  >
                  <a-col :span="24"
                    ><img :src="courseInfo.courseOutline_url" alt=""
                  /></a-col>
                </a-row>
              </div>
              <div class="unit-info" v-if="showUnitInfo">
                <a-card>
                  <h1 class="unit-name">课堂视频</h1>
                  <video
                    class="unit-video"
                    :src="getCoursewareByType(1).mediaPath_url"
                    controls
                    oncontextmenu="return false;"
                    controlsList='nodownload noremote footbar'
                  ></video>
                  <div class="btn-wrap" v-if="departId">
                    <a-button
                      class="btn-white"
                      v-if="
                        courseInfo.openMethod === 1 && !selectedUnit.isVideoOpen
                      "
                      @click="setVideoOpen(1)"
                      >开放视频</a-button
                    >
                    <a-button
                      class="btn-white"
                      v-if="
                        courseInfo.openMethod === 1 && selectedUnit.isVideoOpen
                      "
                      @click="setVideoOpen(0)"
                      >取消开放</a-button
                    >
                    <p></p>
                    <p>视频开放后，将会在学生端显示</p>
                  </div>
                </a-card>
                <a-card v-for="(v, i) in getCoursewareListByType(3)" :key="i">
                  <h1 class="unit-name">
                    课堂案例 {{i+1}}
                  </h1>
                  <a-divider></a-divider>
                  <p class="unit-desc">
                    {{ v.mediaName }}
                  </p>
                  <img class="unit-cover" :src="v.mediaCover_url" alt="" />
                  <div class="btn-wrap">
                    <a
                      v-if="v.mediaPathRaw"
                      class="btn-white"
                      @click="handleViewMedia(v, true)"
                      target="_blank"
                      >查看案例</a
                    >
                    <a
                      class="btn"
                      v-if="v.mediaPath"
                      @click="handleViewMedia(v, false)"
                      target="_blank"
                      >去演示</a
                    >
                  </div>
                </a-card>
                <a-card v-for="(v, i) in getCoursewareListByType(5)" :key="i">
                  <h1 class="unit-name">作业案例 {{i+1}}</h1>
                  <h3>{{ v.mediaName }}</h3>
                  <a-divider></a-divider>
                  <p class="unit-desc">
                    {{ v.mediaDesc }}
                  </p>
                  <img class="unit-cover" :src="v.mediaCover_url" alt="" />
                  <div class="btn-wrap">
                    <a
                      class="btn-white"
                      v-if="v.mediaPathRaw"
                      @click="handleViewMedia(v, true)"
                      target="_blank"
                      >查看案例</a
                    >
                    <a
                      class="btn"
                      v-if="v.mediaPath"
                      @click="handleViewMedia(v, false)"
                      target="_blank"
                      >去演示</a
                    >
                  </div>
                </a-card>
              </div>
            </a-spin>
          </a-layout-content>
        </a-layout>
      </a-layout>
    </a-layout>

    <!-- 布置作业modal -->
    <a-modal
      :visible="showMakeWork"
      :footer="null"
      title="布置作业"
      :width="400"
      @cancel="showMakeWork = false"
    >
      <div v-if="getCoursewareByType(5)">
        <p>课后作业</p>
        <div>
          <a-row>
            <a-col :span="4">
              <a-switch v-model="isWorkOpen" @change="toggleWorkOpen">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </a-col>
            <a-col :span="20">
              <p v-for="(v, i) in getCoursewareListByType(5)" :key="i">
                {{ v.mediaName }}
              </p>
            </a-col>
          </a-row>
        </div>
      </div>
      <div v-if="getCoursewareByType(3)">
        <a-divider></a-divider>
        <p>课堂练习</p>
        <div>
          <a-row>
            <a-col :span="4">
              <a-switch v-model="isWorkCaseOpen" @change="toggleWorkCaseOpen">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </a-col>
            <a-col :span="20">
              <p v-for="(v, i) in getCoursewareListByType(3)" :key="i">
                {{ v.mediaName }}
              </p>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  getTeacherCourse,
  getCourseUnit,
  getDepartUnitSchedule,
  setUnitScheduleManual,
  getCourseCourseware,
} from "@/api/course";
export default {
  name: "TeacherCourseUnitList",
  data() {
    return {
      departId: "",
      courseId: "",
      courseInfo: {},
      courseUnits: [],
      selectedUnit: {},
      selectedMedia: [],
      collapsed: false,
      rootSubmenuKeys: ["sub1", "sub2", "sub4"],
      openKeys: ["sub1"],
      showCourseInfo: true,
      showUnitInfo: false,
      showMakeWork: false,
      isWorkOpen: false,
      isWorkCaseOpen: false,
      spinning: true,
    };
  },
  created() {
    this.courseId = this.$route.query.courseId;
    this.departId = this.$route.query.departId;
    this.getCourse();
    this.getCourseUnit();
  },
  methods: {
    getCourse() {
      this.showCourseInfo = true;
      this.showUnitInfo = false;
      this.selectedUnit = {};
      getTeacherCourse({ courseId: this.courseId }).then((res) => {
        if (res.result && res.result.length > 0) {
          this.courseInfo = res.result[0];
        }
        this.spinning = false;
      });
    },
    getCourseUnit() {
      this.spinning = true;
      if (this.departId) {
        getDepartUnitSchedule(this.courseId, this.departId).then((res) => {
          this.courseUnits = res.result;
          this.spinning = false;
        });
      } else {
        getCourseUnit(this.courseId).then((res) => {
          this.courseUnits = res.result;
          this.spinning = false;
        });
      }
    },
    setVideoOpen(open) {
      var that = this;
      var txt = open == 1 ? "开放" : "取消";
      this.$confirm({
        content: "是否" + txt + "这节课的视频？",
        onOk() {
          setUnitScheduleManual({
            unitId: that.selectedUnit.unitId,
            departId: that.departId,
            isVideoOpen: open,
          }).then((res) => {
            if (res.success) {
              that.$message.success("操作成功");
              that.selectedUnit.isVideoOpen = open == 1 ? 1 : 0;
            }
          });
        },
      });
    },
    toggleWorkOpen() {
      var that = this;
      setUnitScheduleManual({
        unitId: this.selectedUnit.unitId,
        departId: this.departId,
        isWorkOpen: this.isWorkOpen ? 1 : 0,
      }).then((res) => {
        if (res.success) {
          that.$message.success("操作成功");
          that.selectedUnit.isWorkOpen = this.isWorkOpen ? 1 : 0;
        }
      });
    },
    toggleWorkCaseOpen() {
      var that = this;
      setUnitScheduleManual({
        unitId: this.selectedUnit.unitId,
        departId: this.departId,
        isWorkCaseOpen: this.isWorkCaseOpen ? 1 : 0,
      }).then((res) => {
        if (res.success) {
          that.$message.success("操作成功");
          that.selectedUnit.isWorkCaseOpen = this.isWorkCaseOpen ? 1 : 0;
        }
      });
    },
    setUnitOpen(open) {
      var that = this;
      var txt = open == 1 ? "开放" : "取消";
      this.$confirm({
        content: "是否" + txt + "这节课？",
        onOk() {
          setUnitScheduleManual({
            unitId: that.selectedUnit.unitId,
            departId: that.departId,
            isUnitOpen: open,
          }).then((res) => {
            if (res.success) {
              that.$message.success("操作成功");
              that.selectedUnit.isUnitOpen = open == 1 ? 1 : 0;
            }
          });
        },
      });
    },
    //选择单元
    selectUnit(unit) {
      this.spinning = true;
      this.showCourseInfo = false;
      this.showUnitInfo = false;
      this.selectedUnit = unit;
      this.isWorkOpen = unit.isWorkOpen == 1 ? true : false;
      this.isWorkCaseOpen = unit.isWorkCaseOpen == 1 ? true : false;
      console.log(unit);
      let unitId;
      if (this.departId) {
        unitId = unit.unitId;
      } else {
        unitId = unit.id;
      }
      this.selectedMedia = [];
      getCourseCourseware(unitId)
        .then((res) => {
          if (res.success) {
            this.selectedMedia = res.result;
          }
        })
        .finally(() => {
          this.spinning = false;
          this.showUnitInfo = true;
        });
    },
    //开放课件
    openMedia() {},
    handleViewMedia: function (mediaInfo, isRaw) {
      // var mediaInfo = this.getCoursewareByType(mediaType);
      if (mediaInfo == null) {
        return;
      }
      var url;
      switch (mediaInfo.codeType) {
        case 1:
          url =
            "/scratch3/index.html?mediaId=" + mediaInfo.id + "&isRaw=" + isRaw;
          break;
        case 2:
          url =
            "/scratch3/index.html?mediaId=" + mediaInfo.id + "&isRaw=" + isRaw;
          break;
        case 3:
          url =
            "/scratchjr/editor.html?mode=edit&filepath=" +
            mediaInfo.workFile_url;
          break;
        case 4:
          url = "/onlinecode/index.html?lang=turtle&mediaId=" + mediaInfo.id;
          break;
        case 5:
          url = "/onlinecode/index.html?lang=python&mediaId=" + mediaInfo.id;
          break;
        case 6:
          url = "/onlinecode/index.html?lang=c&mediaId=" + mediaInfo.id;
          break;
        case 7:
          url = "/onlinecode/index.html?lang=cpp&mediaId=" + mediaInfo.id;
          break;
        case 8:
          url = "/onlinecode/index.html?lang=java&mediaId=" + mediaInfo.id;
          break;
        default:
          url =
            "/scratch3/index.html?mediaId=" + mediaInfo.id + "&isRaw=" + isRaw;
      }
      window.open(url);
    },
    //根据课件类型获取课件
    getCoursewareByType(type) {
      for (var i = 0; i < this.selectedMedia.length; i++) {
        if (this.selectedMedia[i].mediaType == type) {
          return this.selectedMedia[i];
        }
      }
      return false;
    },
    //根据课件类型获取课件列表
    getCoursewareListByType(type) {
      let courseWareList = [];
      for (var i = 0; i < this.selectedMedia.length; i++) {
        if (this.selectedMedia[i].mediaType == type) {
          courseWareList.push(this.selectedMedia[i]);
        }
      }
      return courseWareList;
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  width: 6px;
  background: #ebebeb;
}
::-webkit-scrollbar-thumb {
  background: #abaaaa;
  border-radius: 3px;
}
.course-prepare-layout {
  height: calc(100vh - 68px);
  overflow: hidden;
}
.btn {
  color: #fff;
  background: @primary-color;
}
.btn-white {
  background: #fff;
  color: @primary-color;
}
.course-prepare-layout {
  min-height: calc(100vh - 68px);
}
.ant-layout {
  padding: 0 !important;
}
.btn-wrap {
  margin-top: 50px;
  text-align: center;
  a,
  button {
    display: inline-block;
    cursor: pointer;
    width: 100px;
    height: 40px;
    margin-right: 16px;
    border: 1px solid @primary-color;
    border-radius: 30px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
  }
}

.schedule-title {
  font-style: normal;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  width: 200px;
  margin-top: 20px;
}
.lesson-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  text-align: center;
  font-size: 30px;
}
.lesson-download {
  font-size: 14px;
  line-height: 20px;
  color: @primary-color;
  margin: 20px;
}

.course-info {
  max-width: 800px;
  margin: auto;
  .ant-row {
    margin: 20px 0;
    img {
      max-width: 800px;
      display: block;
      margin: auto;
    }
  }
  .course-meta-title {
    color: #494949;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
  }
  .course-meta-value {
    color: #494949;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }
}
.unit-info {
  max-width: 800px;
  margin: auto;
  .ant-card {
    margin: 20px 0;
    .unit-name {
      text-align: center;
      font-size: 24px;
      color: #333333;
      line-height: 33px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .unit-cover {
      display: block;
      margin: auto;
      width: 90%;
    }
    .unit-desc {
      font-size: 18px;
      color: #999999;
      line-height: 25px;
      padding: 0 20px;
    }
    .unit-video {
      display: block;
      margin: 20px auto;
      width: 90%;
    }
  }
}
</style>